export const IS_LEGACY_DOMAIN =
  typeof window !== 'undefined' &&
  (window.location.hostname.endsWith('oinglab-korean.com') ||
    (process.env.NODE_ENV === 'development' &&
      localStorage.getItem('dev:legacy') === '1'));

export const NEW_DOMAIN = 'https://www.ko-ready.com';

// 홈 상단 탭 "For Creator" 가 보내는 곳 — Koready Skills 크리에이터 랜딩
export const SKILLS_CREATOR_LANDING_URL =
  'https://skills.ko-ready.com/creators/apply';

export const toNewDomain = (path) =>
  `${NEW_DOMAIN}${path ?? window.location.pathname + window.location.search}`;

// Koready Skills 주소 — 2days project 가 여기로 옮겨 갔다 (로컬 개발은 REACT_APP_SKILLS_URL)
export const SKILLS_URL = (process.env.REACT_APP_SKILLS_URL || 'https://skills.ko-ready.com').replace(/\/+$/, '');
